export const lightTheme = {
    palette: {
      mode: 'light',
      primary: {
        main: "#FFA500",
        light: "#FFB74D",
        dark: "#FF9800",
        contrastText: "#fff",
      },
      secondary: {
        main: "#FF7043",
      },
      background: {
        default: "#f5f5f5",
        paper: "#ffffff",
      },
      text: {
        primary: "#212121",
        secondary: "#757575",
      },
      action: {
        active: '#000',
        hover: 'rgba(0, 0, 0, 0.04)',
        selected: 'rgba(0, 0, 0, 0.12)',
        disabled: 'rgba(0, 0, 0, 0.26)',
      },
    },
    typography: {
      fontFamily: "Poppins, Arial, sans-serif",
      h1: {
        color: "#FFA500",
        fontSize: "2.5rem",
      },
      h2: {
        color: "#FFA500",
        fontSize: "2rem",
      },
      body1: {
        fontSize: "1rem",
      },
      body2: {
        fontSize: "0.875rem",
      },
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: "#FFA500", // Orange app bar for light theme
            color: "#fff",
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            '&:hover': {
              backgroundColor: 'rgba(255, 165, 0, 0.1)',
            },
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          dense: {
            minHeight: "48px !important",
          },
        },
      },
    },
  };
  